// Compatibility with older browsers
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/fn/promise/finally'; // This is for IE11
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';

import {unregister} from './registerServiceWorker';

import App from './components/App';
import reducers from './reducers';


const store = createStore(reducers, {}, applyMiddleware(reduxThunk));

ReactDOM.render(
    <Provider store={store}>
            <App/>
    </Provider>,
    document.getElementById('root')
);
unregister();
